// Wait for the selected section to finish rendering its controls before moving focus.
export function focusTechFormIssue(key: string): () => void {
  const focus = () => {
    const controls = Array.from(
      document.querySelectorAll<HTMLElement>("main [name], main [id], main [data-tech-form-field]"),
    );
    const field = controls.find(
      (control) =>
        control.getAttribute("data-tech-form-field") === key ||
        control.getAttribute("name") === key ||
        control.id === key,
    );
    if (!field) return false;
    const target = field.matches("input, select, textarea, button")
      ? field
      : field.querySelector<HTMLElement>("input, select, textarea, button") || field;
    target.focus();
    target.scrollIntoView({ block: "center", behavior: "smooth" });
    return true;
  };
  if (focus()) return () => {};
  const observer = new MutationObserver(() => {
    if (focus()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  const timeout = window.setTimeout(() => observer.disconnect(), 5000);
  return () => {
    observer.disconnect();
    window.clearTimeout(timeout);
  };
}
